const API_BASE_URL = "https://alcobrakeadmin.com/v3/us";

export const officeAPI = {
  // Fetch all offices
  fetchOffices: async () => {
    const url = `${API_BASE_URL}/caoffices/getalloffices`;
    
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      return data || [];
    } catch (error) {
      console.error("Error fetching offices:", error);
      throw error;
    }
  },

  // Fetch offices for a specific dealer
  fetchDealerOffices: async (dealerId) => {
    const url = `${API_BASE_URL}/caoffices/getdealeroffices?dealerName=${dealerId}`;
    
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      return data || [];
    } catch (error) {
      console.error("Error fetching dealer offices:", error);
      throw error;
    }
  },

  // Add new office
  addOffice: async (officeData) => {
    const url = `${API_BASE_URL}/caoffices/addoffice`;
    
    const formData = new FormData();
    formData.append("officeName", officeData.officeName || "");
    formData.append("officeMobile1", officeData.officeMobile1 || "");
    formData.append("officeMobile2", officeData.officeMobile2 || "");
    formData.append("officeemail", officeData.officeemail || "");
    formData.append("officepassword", officeData.officepassword || "");
    formData.append("officeaddress", officeData.officeaddress || "");
    formData.append("city", officeData.city || "");
    formData.append("state", officeData.state || "");
    formData.append("zipcode", officeData.zipcode || "");
    formData.append("isbar", officeData.isbar || "0");
    formData.append("officelicense", officeData.officelicense || "");
    formData.append("dealer", officeData.dealerId || "");
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      
      const responseText = await response.text();
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error adding office:", error);
      throw error;
    }
  },

  // Edit office
  editOffice: async (officeId, officeData) => {
    const url = `${API_BASE_URL}/caoffices/editoffice/${officeId}`;
    
    const formData = new FormData();
    formData.append("officeName", officeData.officeName || "");
    formData.append("officeMobile1", officeData.officeMobile1 || "");
    formData.append("officeMobile2", officeData.officeMobile2 || "");
    formData.append("officeemail", officeData.officeemail || "");
    // Do not send an empty password when editing: it must keep the existing one.
    if (officeData.officepassword) {
      formData.append("officepassword", officeData.officepassword);
    }
    formData.append("officeaddress", officeData.officeaddress || "");
    formData.append("city", officeData.city || "");
    formData.append("state", officeData.state || "");
    formData.append("zipcode", officeData.zipcode || "");
    formData.append("isbar", officeData.isbar || "0");
    formData.append("officelicense", officeData.officelicense || "");
    formData.append("dealer", officeData.dealerId || "");
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      
      const responseText = await response.text();
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error editing office:", error);
      throw error;
    }
  },

  // Delete office
  deleteOffice: async (officeId) => {
    const url = `${API_BASE_URL}/caoffices/deleteoffice/${officeId}`;
    
    try {
      const response = await fetch(url, {
        method: 'GET',
      });
      
      const responseText = await response.text();
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error deleting office:", error);
      throw error;
    }
  },
};
